import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';

export type AlertTone = 'info' | 'success' | 'warning' | 'error';

@Component({
    selector: 'app-alert',
    standalone: true,
    imports: [CommonModule, MatIconModule],
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
})
export class AlertComponent
{
    @Input() public tone: AlertTone = 'info';
    @Input() public title?: string;
    @Input() public icon?: string;
    @Input() public compact = false;
    @Input() public actionUrl?: string;
    @Input() public actionLabel?: string;
    @Input() public actionNewTab = false;

    public get resolvedIcon(): string
    {
        return this.icon ?? {
            info: 'info',
            success: 'check_circle',
            warning: 'warning',
            error: 'error',
        }[this.tone];
    }

    public get role(): 'alert' | 'status'
    {
        return this.tone === 'error' ? 'alert' : 'status';
    }
}
